import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { Moment } from 'moment'

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateTimeRangePicker } from '@optios/react-date-time-range-picker'

import Button from '../../../../../../App/Components/Button/Button'
import style from '../../style.scss'

import { IProps } from './IProps'

export const DateSelect: FunctionComponent<IProps> = ({
    customer,
    setCustomer,
    setDate,
    setHasDate,
    date,
}) => {
    const { t } = useTranslation()
    return (
        <>
            <div
                className={style.customer}
                onClick={() => setCustomer(undefined)}
            >
                <FontAwesomeIcon
                    icon={faTrashAlt}
                    className={style.deleteIcon}
                />
                {customer.fullName}
            </div>

            <DateTimeRangePicker
                onChange={(selectedDate: Moment) => {
                    setDate(
                        selectedDate
                            .clone()
                            .startOf('day')
                            .minutes(date ? date.minutes() : 0)
                            .hours(date ? date.hours() : 12)
                    )
                    setHasDate(true)
                }}
            />

            <Button type={'button'} onClick={() => setHasDate(false)}>
                {t('No date')}
            </Button>
        </>
    )
}
